import React from 'react';
import { APP_CONFIG_PERMISSION } from 'pages/AppConfig/utils/constants';

const AppConfigPage = React.lazy(() => import('pages/AppConfig/AppConfigPage'));
const AppConfigAddPage = React.lazy(() => import('pages/AppConfig/AppConfigAddPage'));
const AppConfigSettingsPage = React.lazy(() => import('pages/AppConfig/AppConfigSettingsPage'));

const appConfigRoute = [
  {
    path: '/app-config',
    exact: true,
    name: 'App Config master',
    function: APP_CONFIG_PERMISSION.VIEW,
    component: AppConfigPage,
  },
  {
    path: '/app-config/add',
    exact: true,
    name: 'Thêm cấu hình ứng dụng',
    function: APP_CONFIG_PERMISSION.ADD,
    component: AppConfigAddPage,
  },
  {
    path: '/app-config/edit/:id',
    exact: true,
    name: 'Chỉnh sửa cấu hình ứng dụng',
    function: APP_CONFIG_PERMISSION.EDIT,
    component: AppConfigAddPage,
  },
  {
    path: '/app-config/detail/:id',
    exact: true,
    name: 'Chi tiết cấu hình ứng dụng',
    function: APP_CONFIG_PERMISSION.VIEW,
    component: AppConfigAddPage,
  },
  {
    path: '/app-config/page-settings',
    exact: true,
    name: 'Cài đặt theo trang',
    function: APP_CONFIG_PERMISSION.VIEW,
    component: AppConfigSettingsPage,
  },
];

export default appConfigRoute;
